import React from 'react';
export function ProgressionSection() {
  return <section aria-labelledby="progresion" className="bg-stone-100" data-id="element-150" data-mp="2va77u3tqlzht">
      
    </section>;
}